import { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import api from '../../api';
import IdentityContext from '../../contexts/IdentityContext';
import InvitationContext from '../../contexts/InvitationContext';
import useRouting from '../../hooks/useRouting';

export enum GroupInviteState {
  Success = 'Success',
  Failed = 'Failed',
}

export enum GroupInviteMessage {
  AlreadyAccepted = 'AlreadyAccepted',
  NonStudent = 'NonStudent',
  LinkDeprecated = 'LinkDeprecated',
  TooManyMembers = 'TooManyMembers',
  GeneralError = 'GeneralError',
}

const GroupInvite = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { r } = useRouting();

  const { identity } = useContext(IdentityContext);
  const { fetchInvitations } = useContext(InvitationContext);

  useEffect(() => {
    const handleGroupInvite = async () => {
      let state, message;

      try {
        const res = await api.post(`/studio/user/groups/${id}/join`);

        if (res.status === 200) {
          await fetchInvitations();
          return navigate(r('my-teachers'));
        }

        if (res.status === 204) {
          state = GroupInviteState.Success;
          message = GroupInviteMessage.AlreadyAccepted;
        }
      } catch (err) {
        switch ((err as AxiosError).response?.status) {
          case 403:
            state = GroupInviteState.Failed;
            message = GroupInviteMessage.NonStudent;
            break;
          case 404:
            state = GroupInviteState.Failed;
            message = GroupInviteMessage.LinkDeprecated;
            break;
          case 409:
            state = GroupInviteState.Failed;
            message = GroupInviteMessage.TooManyMembers;
            break;
          default:
            state = GroupInviteState.Failed;
            message = GroupInviteMessage.GeneralError;
        }
      }

      return navigate(r('dashboard'), {
        state: {
          groupInviteModal: {
            state,
            message,
          },
        },
      });
    };

    if (identity.isAuthenticated) {
      handleGroupInvite();
    } else {
      navigate(`${r('login')}?returnUrl=${location.pathname}`);
    }
  }, [id, navigate, identity, location, fetchInvitations, r]);

  return null;
};

export default GroupInvite;
